onComplete(function() {
	var navHeader = document.querySelector('.nav-header');
	if (!navHeader) return;

	var onScroll = function() {
		if (window.scrollY > 50) {
			navHeader.classList.add('scrolled');
		} else if (window.scrollY < 20) {
			navHeader.classList.remove('scrolled');
		}
	};

	window.addEventListener('scroll', onScroll, { passive: true });
	onScroll();
});
